var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimeButton',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'PrimeButton',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }